<!--

 -->

<template>
  <div class="gsl-hrm-background-container">
    <div class="gsl-hrm-card-container">
      <oxd-text tag="h6" class="gsl-hrm-main-title">
        {{ $t('time.edit_project') }}
      </oxd-text>
      <oxd-divider />

      <oxd-form :loading="isLoading" @submit-valid="onSave">
        <oxd-grid :cols="2" class="gsl-hrm-full-width-grid">
          <oxd-grid-item>
            <oxd-input-field
              v-model="project.name"
              :label="$t('general.name')"
              :rules="rules.name"
              :disabled="!editMode || !$can.update('time_projects')"
              required
            />
          </oxd-grid-item>
          <oxd-grid-item>
            <customer-autocomplete
              :key="project.customer"
              v-model="project.customer"
              :label="$t('time.customer_name')"
              :rules="rules.customer"
              :disabled="!editMode || !$can.update('time_projects')"
              required
            />
            <oxd-button
              v-if="$can.update(`time_projects`) && editMode"
              icon-name="plus"
              display-type="text"
              class="gsl-hrm-input-field-bottom-space"
              :label="$t('time.add_customer')"
              @click="onClickAddCustomer"
            />
          </oxd-grid-item>
        </oxd-grid>
        <oxd-form-row>
          <oxd-grid :cols="2" class="gsl-hrm-full-width-grid">
            <oxd-grid-item>
              <oxd-input-field
                v-model="project.description"
                type="textarea"
                :label="$t('general.description')"
                :placeholder="$t('general.type_description_here')"
                :rules="rules.description"
                :disabled="!editMode || !$can.update('time_projects')"
              />
            </oxd-grid-item>
            <oxd-grid-item>
              <project-admin-autocomplete
                v-for="(projectAdmin, index) in projectAdmins"
                :key="index"
                v-model="projectAdmin.value"
                :rules="rules.projectAdmin"
                :show-delete="index > 0 && $can.update(`time_projects`)"
                include-employees="onlyCurrent"
                :disabled="!editMode || !$can.update('time_projects')"
                @remove="onRemoveAdmin(index)"
              />
              <oxd-button
                v-if="
                  projectAdmins.length < 5 &&
                  $can.update(`time_projects`) &&
                  editMode
                "
                icon-name="plus"
                display-type="text"
                :label="$t('general.add_another')"
                @click="onAddAnother"
              />
            </oxd-grid-item>
          </oxd-grid>
        </oxd-form-row>
        <oxd-form-row>
          <oxd-grid :cols="2" class="gsl-hrm-full-width-grid">
            <oxd-grid-item>
              <oxd-grid :cols="2" class="gsl-hrm-full-width-grid">
                <oxd-grid-item>
                  <div class="gsl-hrm-sm-field">
                    <oxd-text tag="p" class="gsl-hrm-sm-field-label">
                      {{ $t('general.status') }}
                    </oxd-text>
                    <oxd-switch-input
                      v-model="project.status"
                      :disabled="!editMode || !$can.update('time_projects')"
                    />
                  </div> </oxd-grid-item
              ></oxd-grid>
            </oxd-grid-item>
            <oxd-grid-item>
              <employee-autocomplete
                v-model="project.accountManager"
                :rules="rules.accountManager"
                :label="$t('general.account_manager')"
                :disabled="!editMode || !$can.update('time_projects')"
              />
            </oxd-grid-item>
          </oxd-grid>
        </oxd-form-row>
        <oxd-form-row>
          <oxd-grid :cols="2" class="gsl-hrm-full-width-grid">
            <oxd-grid-item>
              <oxd-input-field
                v-model="project.attendanceRequired"
                type="checkbox"
                value="true"
                :true-value="true"
                :false-value="false"
                option-label="Do you need attendance of this Project to validate Timesheet"
                :label="$t('general.attendance')"
                :disabled="!editMode || !$can.update('time_projects')"
              />
            </oxd-grid-item>
            <oxd-grid-item>
              <oxd-input-field
                v-model="project.agreementSigned"
                type="checkbox"
                value="true"
                :true-value="true"
                :false-value="false"
                option-label="Is this Project has Signed Agreement"
                :label="$t('general.agreement')"
                :disabled="!editMode || !$can.update('time_projects')"
              />
            </oxd-grid-item>
          </oxd-grid>
        </oxd-form-row>
        <oxd-form-row>
          <oxd-grid :cols="2" class="gsl-hrm-full-width-grid">
            <oxd-grid-item>
              <oxd-input-field
                v-model="project.budgetRequired"
                type="checkbox"
                value="true"
                :true-value="true"
                :false-value="false"
                option-label="Configure the Budget for this project"
                :label="$t('general.project_budget')"
                :disabled="!editMode || !$can.update('time_projects')"
              />
            </oxd-grid-item>
          </oxd-grid>
        </oxd-form-row>
        <oxd-text tag="h6" class="gsl-hrm-main-title">
          {{ $t('general.duration') }}
        </oxd-text>
        <oxd-divider />
        <oxd-form-row>
          <oxd-grid :cols="3" class="gsl-hrm-full-width-grid">
            <oxd-grid-item>
              <date-input
                v-model="project.fromDate"
                :label="$t('general.from_date')"
                :rules="rules.fromDate"
                :disabled="!editMode || !$can.update('time_projects')"
              />
            </oxd-grid-item>
            <oxd-grid-item>
              <date-input
                v-model="project.toDate"
                :label="$t('general.to_date')"
                :rules="rules.toDate"
                :disabled="!editMode || !$can.update('time_projects')"
              />
            </oxd-grid-item>
          </oxd-grid>
        </oxd-form-row>
        <oxd-form-row>
          <oxd-text tag="span" class="gsl-hrm-sub-title">
            Total duration: {{ totalDuration || 0 }} days
          </oxd-text>
        </oxd-form-row>
        <oxd-form-row>
          <oxd-text tag="span" class="gsl-hrm-sub-title">
            Total working day: {{ totalWorkingDays || 0 }} days
          </oxd-text>
        </oxd-form-row>
        <br />

        <oxd-divider />
        <oxd-form-row>
          <oxd-grid :cols="3" class="gsl-hrm-full-width-grid">
            <oxd-grid-item>
              <oxd-input-field
                v-model="project.currency"
                type="select"
                :label="$t('general.currency')"
                :options="currencies"
                :disabled="!editMode || !$can.update('time_projects')"
              />
            </oxd-grid-item>
          </oxd-grid>
        </oxd-form-row>

        <oxd-divider />
        <oxd-form-actions>
          <required-text />
          <oxd-button
            display-type="ghost"
            :label="$t('general.back')"
            @click="onCancel"
          />

          <oxd-button
            v-if="!editMode && $can.update(`time_projects`)"
            display-type="main"
            :label="$t('general.edit')"
            style="margin-left: 10px"
            @click="onEditMode"
          />
          <submit-button v-else />
        </oxd-form-actions>
      </oxd-form>
    </div>
    <br />
    <tab-container :tabs="projectTabs">
      <template #budget>
        <project-budget
          v-if="project.budgetRequired"
          :key="`budget-${projectId}-${project.name}`"
          :project-id="projectId"
          :project-details="projectDetails"
          :working-days="totalWorkingDays"
          :project-currency="project?.currency?.id"
        />
      </template>

      <template #activities>
        <activities
          :project-id="projectId"
          :unselectable-ids="unselectableIds"
        />
        <add-customer-modal
          v-if="showCustomerModal"
          @close="onCustomerModalClose"
        ></add-customer-modal>
      </template>

      <template #allocation>
        <project-allocation :project-id="projectId" />
      </template>
    </tab-container>
  </div>
</template>

<script>
import {
  required,
  validSelection,
  validDateFormat,
  startDateShouldBeBeforeEndDate,
  endDateShouldBeAfterStartDate,
  shouldNotExceedCharLength,
} from '@ohrm/core/util/validation/rules';
import {APIService} from '@/core/util/services/api.service';
import {navigate} from '@ohrm/core/util/helper/navigation';
import {promiseDebounce, OxdSwitchInput} from '@ohrm/oxd';
import useEmployeeNameTranslate from '@/core/util/composable/useEmployeeNameTranslate';
import Activities from '@/orangehrmTimePlugin/components/Activities.vue';
import AddCustomerModal from '@/orangehrmTimePlugin/components/AddCustomerModal.vue';
import CustomerAutocomplete from '@/orangehrmTimePlugin/components/CustomerAutocomplete.vue';
import useDateFormat from '@/core/util/composable/useDateFormat';
import ProjectAdminAutocomplete from '@/orangehrmTimePlugin/components/ProjectAdminAutocomplete.vue';
import EmployeeAutocomplete from '@/core/components/inputs/EmployeeAutocomplete';
import TabContainer from '@/core/components/TabContainer';
import ProjectAllocation from '@/orangehrmTimePlugin/components/ProjectAllocation.vue';
import ProjectBudget from '../../components/ProjectBudget.vue';

const defaultProjectModel = {
  name: null,
  customer: {id: null, label: null},
  description: null,
  attendanceRequired: true,
  budgetRequired: true,
  projectAdminEmpNumbers: [],
  fromDate: null,
  toDate: null,
  agreementSigned: true,
  accountManager: null,
  currency: null,
  status: true,
};

export default {
  name: 'ProjectEdit',
  components: {
    activities: Activities,
    'add-customer-modal': AddCustomerModal,
    'customer-autocomplete': CustomerAutocomplete,
    'project-admin-autocomplete': ProjectAdminAutocomplete,
    'employee-autocomplete': EmployeeAutocomplete,
    'project-allocation': ProjectAllocation,
    'oxd-switch-input': OxdSwitchInput,
    'project-budget': ProjectBudget,
    'tab-container': TabContainer,
  },
  props: {
    projectId: {
      type: [String, Number],
      required: true,
    },
    unselectableIds: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const http = new APIService(
      window.appGlobal.baseUrl,
      '/api/v2/time/projects',
    );
    const {userDateFormat} = useDateFormat();

    http.setIgnorePath('/api/v2/time/validation/project-name');
    return {
      http,
      userDateFormat,
    };
  },
  data() {
    return {
      isLoading: false,
      projectAdmins: [{value: null}],
      project: {...defaultProjectModel},
      currencies: [],
      editMode: false,
      showCustomerModal: false,
      rules: {
        name: [required, shouldNotExceedCharLength(50)],
        description: [shouldNotExceedCharLength(255)],
        customer: [required, validSelection],
        projectAdmin: [
          validSelection,
          (value) => {
            return this.projectAdmins.filter(
              ({value: admin}) => admin && admin.id === value?.id,
            ).length < 2
              ? true
              : this.$t('general.already_exists');
          },
        ],
        fromDate: [
          validDateFormat(this.userDateFormat),
          startDateShouldBeBeforeEndDate(
            () => this.project.toDate,
            this.$t('general.from_date_should_be_before_to_date'),
            {allowSameDate: true},
          ),
        ],
        toDate: [
          validDateFormat(this.userDateFormat),
          endDateShouldBeAfterStartDate(
            () => this.project.fromDate,
            this.$t('general.to_date_should_be_after_from_date'),
            {allowSameDate: true},
          ),
        ],
        accountManager: [validSelection],
      },
    };
  },
  computed: {
    totalDuration() {
      if (!this.project.fromDate || !this.project.toDate) return null; // Ensure both dates exist

      const fromDate = new Date(this.project.fromDate);
      const toDate = new Date(this.project.toDate);

      if (isNaN(fromDate) || isNaN(toDate)) return null; // Handle invalid dates

      const durationInMilliseconds = toDate - fromDate;
      return Math.ceil(durationInMilliseconds / (1000 * 60 * 60 * 24)); // Convert ms to days
    },
    projectDetails() {
      return {
        projectName: `${this.project.name} - ${this.project.customer?.label}`,
        fromDate: this.project.fromDate,
        toDate: this.project.toDate,
      };
    },
    totalWorkingDays() {
      if (!this.project.fromDate || !this.project.toDate) return null;

      let fromDate = new Date(this.project.fromDate);
      let toDate = new Date(this.project.toDate);

      if (isNaN(fromDate) || isNaN(toDate)) return null; // Handle invalid dates

      let count = 0;

      while (fromDate <= toDate) {
        const dayOfWeek = fromDate.getDay(); // 0 = Sunday, 6 = Saturday
        if (dayOfWeek !== 0 && dayOfWeek !== 6) {
          count++; // Only count weekdays (Monday to Friday)
        }
        fromDate.setDate(fromDate.getDate() + 1); // Move to next day
      }

      return count;
    },
    projectTabs() {
      const tabs = [
        {name: 'activities', label: this.$t('time.activities')},
        {name: 'allocation', label: this.$t('Allocation')},
      ];
      if (this.project.budgetRequired) {
        tabs.push({name: 'budget', label: this.$t('Budget')});
      }
      return tabs;
    },
  },

  beforeMount() {
    this.isLoading = true;
    const {$tEmpName} = useEmployeeNameTranslate();
    this.http
      .get(this.projectId, {model: 'detailed'})
      .then((response) => {
        const {data} = response.data;
        this.project.name = data.name;
        this.project.status = data.status;
        this.project.description = data.description;
        this.project.attendanceRequired = data.attendanceRequired;
        this.project.budgetRequired = data.budgetRequired;
        this.project.agreementSigned = data.agreementSigned;
        this.project.accountManager = data.accountManager.empNumber
          ? {
              id: data.accountManager?.empNumber,
              label: `${data.accountManager?.firstName} ${data.accountManager?.middleName} ${data.accountManager?.lastName}`,
              isPastEmployee: data.accountManager?.terminationId,
            }
          : null;
        this.project.fromDate = data.fromDate?.date?.split(' ')[0];
        this.project.toDate = data.toDate?.date?.split(' ')[0];
        this.project.customer = {
          id: data.customer.id,
          label: data.customer.name,
        };
        if (
          Array.isArray(data.projectAdmins) &&
          data.projectAdmins.length > 0
        ) {
          this.projectAdmins = data.projectAdmins.map((projectAdmin) => {
            return {
              value: {
                id: projectAdmin.empNumber,
                label: $tEmpName(projectAdmin, {
                  includeMiddle: true,
                  excludePastEmpTag: true,
                }),
                isPastEmployee: projectAdmin.terminationId ? true : false,
              },
            };
          });
        }
        if (data?.currencyType?.id && data?.currencyType?.name) {
          this.project.currency = {
            id: data?.currencyType?.id,
            label: `${data?.currencyType?.id} - ${data?.currencyType?.name}`,
          };
        }
      })
      .finally(() => {
        this.rules.name.push(promiseDebounce(this.validateProjectName, 500));
        this.isLoading = false;
      });

    this.http
      .request({
        method: 'GET',
        url: `/api/v2/admin/pay-grades/1/currencies/allowed`,
        params: {
          limit: 0,
        },
      })
      .then((response) => {
        const {data} = response.data;

        // Move the currencies with specific codes (51, 64, 151) to the top
        const topCodes = [51, 67, 151];
        const topCurrencies = data.filter((item) =>
          topCodes.includes(item.code),
        );
        const otherCurrencies = data.filter(
          (item) => !topCodes.includes(item.code),
        );

        // Concatenate the top currencies followed by the other currencies
        this.currencies = [...topCurrencies, ...otherCurrencies].map((item) => {
          return {
            id: item.id,
            label: item.id + ' - ' + item.name,
          };
        });
      })
      .finally(() => {
        this.isLoading = false;
      });
  },

  methods: {
    onClickAddCustomer() {
      this.showCustomerModal = true;
    },
    onCustomerModalClose(data) {
      if (data !== undefined) {
        const {id, name} = data;
        this.project.customer = {
          id,
          label: name,
        };
      }
      this.showCustomerModal = false;
    },
    onAddAnother() {
      if (this.projectAdmins.length < 5) {
        this.projectAdmins.push({value: null});
      }
    },
    onRemoveAdmin(index) {
      this.projectAdmins.splice(index, 1);
    },
    onCancel() {
      navigate('/time/viewProjects');
    },
    onEditMode() {
      this.editMode = true;
    },
    onSave() {
      this.isLoading = true;
      this.http
        .update(this.projectId, {
          name: this.project.name,
          description: this.project.description,
          customerId: this.project.customer.id,
          attendanceRequired: this.project.attendanceRequired,
          budgetRequired: this.project.budgetRequired,
          agreementSigned: this.project.agreementSigned,
          projectAdminsEmpNumbers: this.projectAdmins
            .map(({value}) => value && value.id)
            .filter(Number),
          fromDate: this.project.fromDate,
          toDate: this.project.toDate,
          accountManager: this.project.accountManager?.id,
          currencyId: this.project.currency?.id,
          status: this.project.status,
        })
        .then(() => {
          return this.$toast.updateSuccess();
        })
        .then(() => {
          this.isLoading = false;
          this.editMode = false;
        });
    },
    validateProjectName(project) {
      return new Promise((resolve) => {
        if (project) {
          this.http
            .request({
              method: 'GET',
              url: `/api/v2/time/validation/project-name`,
              params: {
                projectId: this.projectId,
                projectName: this.project.name.trim(),
                customerId: this.project.customer?.id,
              },
            })
            .then((response) => {
              const {data} = response.data;
              return data.valid === true
                ? resolve(true)
                : resolve(this.$t('general.already_exists'));
            });
        } else {
          resolve(true);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.gsl-hrm-sm-field {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: $oxd-input-control-vertical-padding 0rem;
  &-label {
    font-weight: 700;
    font-size: $oxd-input-control-font-size;
  }
}
</style>
